export default __webpack_public_path__ + "2f817c7c1cf7a5243d1afb50473f02ed.svg";